import { StandaloneMarkup } from 'base/components/Markup';
import useUserAuth from 'lib/hooks/useUserAuth';
import { useAppState } from '@/hooks/useAppState';

export const AllasStandaloneMarkup: typeof StandaloneMarkup = ({ markup, ...props }) => {
  const { isUserLoggedIn } = useUserAuth();
  const [{ userInfo }] = useAppState();

  const showMemberMarkup = isUserLoggedIn && markup?.includes('id="allas-member-welcome"');

  const memberMarkup = (
    <div className="mt-3 bg-logga-300 p-6 text-center">
      <h2 className="mb-3 text-headline-sm">Välkommen {userInfo?.firstName}</h2>
      <div className="text-body-md">
        Vill du hantera dina print-prenumerationer?{' '}
        <a href="https://prenumerera.se/kundservice/" className="font-normal hover:underline">
          Det kan du göra här
        </a>
      </div>
    </div>
  );

  return showMemberMarkup ? memberMarkup : <StandaloneMarkup {...{ markup }} {...props} />;
};
